import React from 'react';
import type { CommonModalProps } from 'components/common/modal';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import Modal from 'components/common/modal';
import ControlledSaveDiscardButtons from 'components/common/form-controlled/controlled-save-discard-buttons';
import type { ControlledSaveDiscardButtonsProps } from 'components/common/form-controlled/controlled-save-discard-buttons';

// antd prefers `destroyOnHidden`, so a caller's deprecated `destroyOnClose` would lose to the default below.
interface Props extends Omit<CommonModalProps, 'destroyOnClose'> {
  form: UseFormReturnType;
  saveMessageId?: string;
  onCancel: () => void;
  saveButtonDataE2E?: string;
  cancelButtonDataE2E?: string;
  saveDiscardProps?: Partial<ControlledSaveDiscardButtonsProps>;
}

const ControlledModal: React.FC<Props> = ({
  form,
  onCancel,
  children,
  saveMessageId,
  saveButtonDataE2E,
  cancelButtonDataE2E,
  saveDiscardProps,
  ...props
}) => {
  return (
    <Modal
      centered
      destroyOnHidden
      onCancel={() => onCancel()}
      footer={
        <ControlledSaveDiscardButtons
          form={form}
          saveMessageId={saveMessageId}
          onDiscard={onCancel}
          alwaysEnableDiscard={true}
          saveButtonDataE2E={saveButtonDataE2E}
          cancelButtonDataE2E={cancelButtonDataE2E}
          {...saveDiscardProps}
        />
      }
      {...props}>
      {children}
    </Modal>
  );
};

export default ControlledModal;
